import { cookieKeysEnum } from "models/common.models";

export const getDomain = () => {
	if (document.domain && document.domain.length) {
		let parts = document.domain.replace(/^(www\.)/, '').split('.')
		while (parts.length > 2) {
			// eslint-disable-next-line no-unused-vars
			let subdomain = parts.shift()
		}
		let domain = parts.join('.');

		return domain.replace(/(^\.*)|(\.*$)/g, '')
	}
	return ''
}
export const deleteAllCookies = () => {
	let cookies = document.cookie.split(';')
	for (let i = 0; i < cookies.length; i++) {
		let cookie = cookies[i]
		let eqPos = cookie.indexOf('=')
		let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
		document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=' + getDomain() + ';path=/'
	}
}
export const setCookie = (cookieName, token, toExpire = 1, isHours = true) => {
	let date = new Date()
	if (isHours) {
		date.setTime(date.getTime() + (toExpire * 60 * 60 * 1000))
	} else {
		date.setTime(date.getTime() + (toExpire * 60 * 1000))
	}
	let documentDomain = cookieName == 'open-auth-token' ? document.domain : getDomain();
	let secureFlag = window.location.hostname !== 'localhost' ? ';secure' : ''
	document.cookie = cookieName + '=' + token + '; expires=' + date.toUTCString() + ';domain=' + documentDomain + ';path=/' + secureFlag
}

export const setRedirectUrl = (value) => {
    setCookie(cookieKeysEnum["REDIRECT-URL"], value, process.env.REACT_APP_COOKIES_EXPIRATION_TIME);
}

export const getCookie = (cookieName) => {
	const name = cookieName + '='
	const allCookieArray = document.cookie.split(';')
	for (let i = 0; i < allCookieArray.length; i++) {
		const temp = allCookieArray[i].trim()
		if (temp.indexOf(name) == 0) {
			return temp.substring(name.length, temp.length)
		}
	}
	return ''
}
export const removeCookie = (cookieName) => {
	document.cookie = cookieName + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=' + getDomain() + ';path=/'
}

export const getPlainCookie = (cookieName) => {
	const name = cookieName + '='
	const allCookieArray = document.cookie.split(';')
	for (let i = 0; i < allCookieArray.length; i++) {
		const temp = allCookieArray[i].trim()
		if (temp.indexOf(name) === 0) {
			return temp.substring(name.length, temp.length)
		}
	}
	return ''
}
export default {
	setCookie,
	getPlainCookie,
	getCookie,
	deleteAllCookies,
	removeCookie,
	setRedirectUrl
}